
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(134|2642|4075)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
